module.exports = __webpack_public_path__ + "img/AP9_tlo.f4b84b8b.jpg";